import { type AsyncState, createAsyncStateReducer } from '@essent/common';
import type { GetOnlineAccountV2Response } from '@integration/api-client/consumer';
import type { ActionReducerMap } from '@ngrx/store';

import { consumerActions } from './consumer.entity';

export const consumerEntitySelectorKey = 'consumer-entity';

export interface ConsumerEntityState {
  getOnlineAccount: AsyncState<GetOnlineAccountV2Response>;
}

export const consumerEntityReducers: ActionReducerMap<ConsumerEntityState> = {
  getOnlineAccount: createAsyncStateReducer(consumerActions.getOnlineAccountV2),
};
